import { 
    currency,
    DEFAULT_CURRENCY_MIN_DECIMALS,
    DEFAULT_CURRENCY_MAX_DECIMALS 
} from "../../../filters";

export const mapPrice = (price, minDecimals = DEFAULT_CURRENCY_MIN_DECIMALS, maxDecimals = DEFAULT_CURRENCY_MAX_DECIMALS) => {
    return `${currency(price, minDecimals, maxDecimals)}`;
};
